// The one cache policy (docs/architecture.md "Caching"). Every query in the SPA picks a tier
// by what the data IS, so the number of calls follows the data's rate of change, not the
// number of screens that happen to read it:
//
//   static  — the resource registry (/meta): fixed for a deployment. Fetched once per session.
//   session — who-am-I (/me), onboarding state, entitlements: fixed for a sign-in; a write that
//             changes them (a role change, a plan change) invalidates explicitly.
//   config  — catalogs and settings (statuses, priorities, queues, types, outcomes, client
//             types, technicians…): change when an admin edits them. Long-lived, and every
//             mutation through the engine invalidates its own resource (useInvalidateResource),
//             so an edit is visible at once without polling.
//   live    — business records (tickets, clients, invoices…): fresh on every screen entry,
//             kept while the user is on it; mutations invalidate.
//   poll    — inboxes (notifications, announcements): refetched on an interval.
export const CACHE = {
  static: { staleTime: Infinity, gcTime: Infinity },
  session: { staleTime: Infinity, gcTime: Infinity },
  config: { staleTime: 15 * 60_000, gcTime: 60 * 60_000 },
  live: { staleTime: 15_000 },
  poll: { staleTime: 30_000, refetchInterval: 60_000, refetchIntervalInBackground: false },
} as const;
